import { TenantConfiguration } from '@msdk/definitions'
import { startTransition, useEffect } from 'react'
import { useRecoilState, useRecoilValueLoadable } from 'recoil'

import { $tenantConfiguration } from '../tenant-configuraiton'
import { $componentLibrary } from './atom'

type WindowWithComponentLibrary = typeof window & { __COMPONENT_LIBRARY__: string | undefined }

type ComponentLibraryType = 'mui' | 'nova'

// see also packages\ui\src\hooks\useComponentLibrary.ts
const DEFAULT_COMPONENT_LIBRARY = 'nova' as ComponentLibraryType

export function useTenantComponentLibrarySetting() {
  const [componentLibrary, setComponentLibrary] = useRecoilState($componentLibrary)
  const tenantConfigurationLoadable = useRecoilValueLoadable($tenantConfiguration)

  useEffect(() => {
    if (tenantConfigurationLoadable.state !== 'hasValue') {
      return
    }

    const tenantConfiguration = tenantConfigurationLoadable.contents as TenantConfiguration | undefined
    if (!tenantConfiguration) {
      return
    }

    const toSetcomponentLibrary = tenantConfiguration.componentLibrary ?? DEFAULT_COMPONENT_LIBRARY
    if (componentLibrary !== toSetcomponentLibrary) {
      startTransition(() => {
        const windowWithComponentLibrary = window as WindowWithComponentLibrary
        windowWithComponentLibrary.__COMPONENT_LIBRARY__ = toSetcomponentLibrary
        document.body.dataset.componentLibrary = toSetcomponentLibrary

        setComponentLibrary(toSetcomponentLibrary)
      })
    }
  }, [componentLibrary, setComponentLibrary, tenantConfigurationLoadable])

  return { componentLibrary }
}
